import { render, staticRenderFns } from "./StaffCampusTransferPrint.vue?vue&type=template&id=026aeff3&scoped=true&"
import script from "./StaffCampusTransferPrint.vue?vue&type=script&lang=js&"
export * from "./StaffCampusTransferPrint.vue?vue&type=script&lang=js&"
import style0 from "./StaffCampusTransferPrint.vue?vue&type=style&index=0&id=026aeff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026aeff3",
  null
  
)

export default component.exports